import { gql } from "@apollo/client";

export const CANCEL_TRACKED_JOB = gql`
  mutation cancelTrackedJob($jobId: String!) {
    cancelTrackedJob(input: { trackedJobId: $jobId })
  }
`;
